"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLootboxRedemptionsSortToJSON = exports.GetLootboxRedemptionsSortFromJSONTyped = exports.GetLootboxRedemptionsSortFromJSON = exports.GetLootboxRedemptionsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetLootboxRedemptionsSort;
(function (GetLootboxRedemptionsSort) {
    GetLootboxRedemptionsSort["CreatedAt"] = "createdAt";
})(GetLootboxRedemptionsSort = exports.GetLootboxRedemptionsSort || (exports.GetLootboxRedemptionsSort = {}));
function GetLootboxRedemptionsSortFromJSON(json) {
    return GetLootboxRedemptionsSortFromJSONTyped(json, false);
}
exports.GetLootboxRedemptionsSortFromJSON = GetLootboxRedemptionsSortFromJSON;
function GetLootboxRedemptionsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetLootboxRedemptionsSortFromJSONTyped = GetLootboxRedemptionsSortFromJSONTyped;
function GetLootboxRedemptionsSortToJSON(value) {
    return value;
}
exports.GetLootboxRedemptionsSortToJSON = GetLootboxRedemptionsSortToJSON;
